import isEmail from "validator/lib/isEmail"; // eslint-disable-line
import isMobilePhone from "validator/lib/isMobilePhone"; // eslint-disable-line
import isPostalCode from "validator/lib/isPostalCode"; // eslint-disable-line
import isInt from "validator/lib/isInt"; // eslint-disable-line
import normalizeEmail from "validator/lib/normalizeEmail"; // eslint-disable-line
import escape from "validator/lib/escape"; // eslint-disable-line
import httpA from "./actions/httpActions"; // eslint-disable-line
import ObjectAssignDeep from "@kyleshockey/object-assign-deep"; // eslint-disable-line
import qs from 'qs';
import PasswordChecker from './modules/form/passwordChecker';

document.addEventListener('DOMContentLoaded', () => {
    const togglePassVisib = document.getElementsByClassName('input__password_toggle');

    Array.prototype.forEach.call(togglePassVisib, (el) => {
        el.addEventListener('click', () => {
            el.classList.toggle('text');

            const input = el.previousElementSibling;
            input.type = input.type === 'password' ? 'text' : 'password';
        });
    });
});

const getParentElement = (element, depth) => {
    let parent = element;
    if (depth > 0) {
        for (let i = 0; i < depth; i += 1) if (parent.tagName !== 'HTML') parent = parent.parentElement;
    }

    return parent;
};

const showCondElement = (field) => {
    const condFields = document.querySelectorAll(`[data-condName="${field.name}"]`);

    condFields.forEach((condField) => {
        let { value } = field;

        if (field.tagName === 'select') value = field.querySelector('option:selected');

        if (value === condField.dataset.condvalue) {
            getParentElement(condField, 2).classList.remove('hide'); // Climb to input__wrap parent
            condField.setAttribute('required', 'required');
            condField.removeAttribute('data-ignore');
        } else {
            getParentElement(condField, 2).classList.add('hide');
            condField.removeAttribute('required');
            condField.setAttribute('data-ignore', 1);
        }
    });
};

class FormError extends Error {
    constructor(...args) {
        super(args);
        if (Error.captureStackTrace) Error.captureStackTrace(this, FormError);
    }
}

class Form {
    constructor(node, customOptions = {}) {
        this.form = node;
        this.options = ObjectAssignDeep.noMutate(Form.DEFAULT_CONFIG, customOptions);

        this.fields = [];
        this.submit = null;
        this.metter = null;

        this.fileponds = false;
        this.locale = 'fr-FR';
        this.action = null;

        this.pwdMin = this.options.pwdMin ? this.options.pwdMin : 3;
        this.passwords = [];
        this.errors = {};
        this.fileHasError = false;

        this.data = {
            fields: {},
        };

        this.events = {
            [Form.EVENT_SUBMIT]: null,
            [Form.EVENT_SUBMIT_COMPLETED]: null,
            [Form.EVENT_SUBMIT_FAILED]: null,
        };

        this.setErrorMessages('MESSAGES', window.MESSAGES);
    }

    setErrorMessages(label, value) {
        if (typeof value === 'object') {
            this[label] = value;
        } else {
            if (this.options.debug) console.warn(`Missing ${label} constant @ #${this.form.id}`); // eslint-disable-line
            this[label] = {};
        }
    }

    setupFields() {
        const query = 'input:not([type="submit"]):not([name="action"]):not([name="locale"]):not([type="search"]), textarea, select';
        this.fields = Array.from(this.form.querySelectorAll(query));

        this.metter = document.getElementById('metter');
        this.submit = this.form.querySelector('[type=submit]');
    }

    changeCallback(field) {
        const parent = field.parentNode;
        if (field.type !== 'hidden') {
            if (field.value === '') parent.classList.remove('filled');
            else parent.classList.add('filled');
        }

        if (this.validate(field)) this.enableSubmit();
        else this.disableSubmit();
    }

    static initFieldEventListener(field) {
        if (field.type === 'hidden') return;

        const parent = field.parentNode;

        if (field.value === '') parent.classList.remove('filled');
        else parent.classList.add('filled');

        field.addEventListener('focusin', () => {
            if (!parent.classList.contains('touched')) parent.classList.add('touched');
            parent.classList.add('focused');
        });

        field.addEventListener('focusout', () => {
            parent.classList.remove('focused');
        });

        if (field.dataset.cond) {
            showCondElement(field);
            if (field.tagName === 'select') {
                field.addEventListener('change', () => {
                    showCondElement(field);
                });
            } else {
                field.addEventListener('input', () => {
                    showCondElement(field);
                });
            }
        }
    }

    init(fileponds = false) {
        if (!this.form) throw new FormError(`Form not found @ #${this.form.id}`);

        /**
         * Setup the Form entity fields
         */
        this.setupFields();
        if (fileponds) this.fileponds = fileponds;

        const locale = this.form.querySelector('input[name=locale]');
        if (locale) {
            if (!locale.value) throw new FormError(`Custom locale is set but invalid @ #${this.form.id}`);
            this.locale = locale.value;
        }

        const action = this.form.querySelector('input[name=action]');
        if (action && action.value) this.action = action.value;
        else throw new FormError(`Action field missing @ #${this.form.id}`);

        /**
         * Init eventlistener
         */
        this.fields.forEach(Form.initFieldEventListener);

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        this.form.addEventListener(
            'change',
            ({ target }) => {
                if (this.fields.indexOf(target) !== -1) {
                    setTimeout(
                        () => {
                            this.changeCallback(target);
                        },
                        isSafari ? 100 : 0,
                    );
                }
            },
            true,
        );

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.disableSubmit();
            this.submitFunction();
        });

        /*
         * DEFAULT SUBMIT BEHAVIOURS
         * You can overwrite submit / submit.completed / submit.failed
         */

        /**
         * When the request is succesfully completed
         */
        // eslint-disable-line consistent-return
        this.on(Form.EVENT_SUBMIT_COMPLETED, (result) => {
            const { form } = this;
            const state = form.querySelector('.form__state');
            const { code, redirect: resultRedirect } = result.data;
            const successCodes = ['U1CREA', 'U1RESPWD', 'U1LOG'];

            state.innerHTML = '';
            state.style.marginBottom = '20px';

            if (successCodes.includes(code)) window.location.href = resultRedirect;

            state.textContent = this.getMessage(code);

            form.classList.remove('failed');
            form.classList.add('complete');

            this.disable();

            const redirect = typeof resultRedirect === 'undefined'
                ? form.querySelector('[name="conf"]').value
                : resultRedirect;

            if (redirect !== '') window.location.href = redirect;
        });

        this.on(Form.EVENT_SUBMIT_FAILED, (result) => {
            const code = result.code || result.data.code;

            const state = this.form.querySelector('.form__state');
            state.classList.add('show');
            state.innerHTML = '';

            const message = document.createElement('div');
            message.classList.add('form__message');

            if (code !== 'U0LPWD') {
                message.classList.add('failed');
                this.form.classList.add('failed');
            } else {
                message.classList.add('complete');
            }

            this.form.classList.add('failed');

            message.innerText = this.getMessage(code);

            state.appendChild(message);

            setTimeout(() => {
                this.enableSubmit();
            }, 2500);
        });
    }

    /**
     * Overwrite default event handlers
     * @param {Node} field
     * @return {bool}
     */
    on(name, callback) {
        const { id } = this.form;
        if (typeof callback !== 'function') throw new FormError(`Invalid callback for "${name}" event @ #${id}`);
        if (!Object.hasOwnProperty.call(this.events, name)) throw new FormError(`Could not add event "${name}" @ #${id}`);

        this.events[name] = callback;
    }

    /**
     * Add a custom event listener
     * @param {int} Score for password
     * @return {}
     */
    metterBar(score) {
        if (!this.metter) return;

        const metterBar = this.metter.querySelector('#metterBar');
        metterBar.setAttribute('data-strength', score);
    }

    /**
     * Test a specific field for validation
     * @param {Node} field
     * @return {bool}
     */
    validate(field) {
        const parent = field.parentElement;
        const messageElem = parent.nextElementSibling;

        const test = this.testField(field);
        const { name, value } = test;
        const { success, message } = test;

        /**
         * Register form values in this.data.fields
         */
        if (name === '') {
            if (this.options.debug) console.warn(`Field "${field.id}" has no name`); // eslint-disable-line
        } else if (field.dataset.ignore !== '1') this.data.fields[name] = value;

        /**
         * Display global form's message changes
         */
        if (!success) {
            if (messageElem) messageElem.innerHTML = message;

            if (field.type !== 'hidden') {
                parent.classList.remove('valid');
                parent.classList.add('invalid');
            }
        } else if (field.type !== 'hidden') {
            if (messageElem) messageElem.innerHTML = '';

            parent.classList.add('valid');
            parent.classList.remove('invalid');
        }

        return success;
    }

    cleanFilepond(root) {
        root.nextElementSibling.innerHTML = ""; // eslint-disable-line
        this.fields.forEach((input, index) => {
            if (input.classList.contains('filepond--browser')) this.fields.splice(index, 1);
        });

        this.fileHasError = false;
    }

    validateFilepond() {
        if (!this.form.querySelector('.filepond--root')) return false;

        let isValid = true;

        this.form.querySelectorAll('.filepond--root').forEach((root) => {
            const files = root.querySelectorAll('.filepond--data input');
            if (files.length < 1) {
                if (!root.querySelector('.filepond--browser').hasAttribute('required')) return false;
                if (this.fileHasError) {
                    isValid = false;
                } else {
                    const browser = root.querySelector('.filepond--browser');
                    const { code } = root.parentElement.dataset;
                    browser.setAttribute('data-code', code);
                    this.fields.push(browser);
                }
            } else this.cleanFilepond(root);

            return true;
        });

        return isValid;
    }

    /**
     * Test all fields for validation and returns true if everything is ok
     * @return {bool}
     */
    validateAll() {
        const filepondSuccess = this.validateFilepond();

        const success = filepondSuccess
            && this.fields.reduce((bool, field) => {
                const validated = this.validate(field); // must keep this line
                return bool && validated;
            }, true);

        if (!success) this.form.scrollIntoView({ behavior: 'smooth' });

        return success;
    }

    /**
     * Validates a field and returns validation data
     * @param {Node} field
     * @return {Object}
     */
    testField(field) {
        let value = escape(field.value);
        const {
            name,
            dataset: { code },
            type,
            required,
            checked,
            pattern,
        } = field;

        if (type === 'hidden' && value === '') {
            throw new FormError(`Empty hidden field "${name}" @ #${this.form.id}`);
        }

        let empty = value === '';
        let valid = false;
        let prefix = null;
        let customMessage = null;

        switch (type) {
        case 'file': {
            valid = true; // TODO: filevalidation
            prefix = 'FOR';
            break;
        }
        case 'radio': {
            const elem = document.querySelector(`input[name="${name}"]:checked`);
            value = elem !== null ? elem.value : '';
            valid = value !== '';
            break;
        }
        case 'number': {
            const optionNumber = {};

            const min = field.getAttribute('min');
            const max = field.getAttribute('max');
            if (min) optionNumber.min = parseInt(min, 10);
            if (max) optionNumber.max = parseInt(max, 10);

            valid = isInt(value, optionNumber);
            prefix = 'FOR';
            // TODO: custom message on only min / only max
            customMessage = `Le nombre doit être compris entre ${min} et ${max}`;
            break;
        }
        case 'checkbox': {
            value = document.querySelector(`input[name="${name}"]:checked`) !== null ? 1 : 0;
            empty = !checked;
            valid = !required || checked;
            break;
        }

        default:
            switch (code) {
            // Email
            case 'EMA': {
                value = normalizeEmail(value);
                empty = value === '';
                valid = isEmail(normalizeEmail(value)) && Form.validateEmailNotOnlyNumber(value);
                prefix = 'FOR';
                break;
            }

            // Phone
            case 'PHO': {
                // Use intl-phone validation
                // value = value.replaceAll(/\s|\./g, '');

                // valid = isMobilePhone(value, this.locale, this.options.strictMode)
                //             || Form.validateFrenchPhone(value);
                // prefix = 'FOR';

                valid = true;
                break;
            }

            // Password
            case 'PAS': {
                if (value.length < 6) {
                    this.metterBar(0);
                    valid = false;
                    prefix = 'FOR';
                    customMessage = 'Minimum 6 caractères';
                    break;
                }

                const result = new PasswordChecker(value);
                let warning = '';
                if (result.score < this.pwdMin) warning = 'Votre mot de passe doit faire au minimum 8 caractères, comprendre des minuscules, majuscules, chiffres et caractères spéciaux (@#&!-$*%+/?).';

                valid = result.score >= this.pwdMin;
                prefix = 'FOR';
                customMessage = warning;
                this.metterBar(result.score);
                break;
            }

            // Confirm password
            case 'CPA': {
                const passwordField = this.form.querySelector('input[name="password"]');
                if (!passwordField) throw new FormError(`Password field not found @ #${this.form.id}`);

                valid = passwordField.value === value;
                prefix = 'DIF';
                break;
            }

            // Zipcode
            case 'ZIP': {
                const { locale } = this;
                valid = isPostalCode(value, locale.substring(locale.length - 2));
                prefix = 'FOR';
                break;
            }

            default:
                if (field.classList.contains('slimselect')) {
                    // select
                    value = Form.getSelectValues(field);
                    empty = value === '';
                    valid = !pattern || value.match(pattern);
                    prefix = 'FOR';
                } else {
                    // Text / textarea / other fields
                    valid = !pattern || value.match(pattern);
                    prefix = 'FOR';
                }
            }
        }

        return this.feedback(code, name, value, required, empty, valid, prefix, customMessage);
    }

    /**
     * Triggers form submit
     * @return {void}
     */
    submitFunction() {
        if (this.events[Form.EVENT_SUBMIT]) this.events[Form.EVENT_SUBMIT]();

        if (!this.validateAll()) {
            if (this.events[Form.EVENT_SUBMIT]) this.events[Form.EVENT_SUBMIT]({ code: 'F0VALCLI' });
            return this.setSubmitLabel();
        }

        let waitSubmit = [];

        if (this.fileponds) {
            Array.from(this.fileponds).forEach(async (pond) => {
                const filesElements = pond.element.querySelectorAll('.filepond--data input[type="hidden"]');
                const { required, name } = pond;

                if ((!required && filesElements.length > 0) || required) {
                    waitSubmit = [...waitSubmit, pond];
                    // eslint-disable-next-line
                    pond.onprocessfiles = () => {
                        this.becauseMagic(pond);
                    };

                    const state = this.form.querySelector('.form__state');
                    state.classList.add('show');
                    state.innerHTML = '';

                    const message = document.createElement('div');
                    message.classList.add('form__message', 'complete');
                    message.textContent = this.getMessage('F2FILPRO');
                    state.appendChild(message);

                    const { classList } = this.form;
                    classList.remove('failed', 'complete');
                    classList.add('processing');

                    pond.processFiles();
                } else {
                    this.data.fields[name] = '';
                }
            });
            window.addEventListener('express_filepond_uploaded', ({ detail }) => {
                if (waitSubmit.length && detail) {
                    waitSubmit = waitSubmit.filter((pond) => detail.id !== pond.id);
                }

                if (waitSubmit.length === 0) this.applySubmit();
            });
            window.dispatchEvent(new CustomEvent('express_filepond_uploaded'));
        } else {
            this.applySubmit();
        }

        return true;
    }

    // because of processFiles().then executing before the promise itself
    becauseMagic(filepond) {
        const filesElements = filepond.element.querySelectorAll('.filepond--data input[type="hidden"]');

        if (filesElements.length > 0) {
            const filesData = {};
            Array.from(filesElements).forEach((el) => {
                if (typeof filesData[el.name] !== 'object') filesData[el.name] = [];
                filesData[el.name].push(el.getAttribute('value'));
            });

            this.data.fields = { ...this.data.fields, ...filesData };
        }

        window.dispatchEvent(new CustomEvent('express_filepond_uploaded', { detail: filepond }));
    }

    // TODO:
    applySubmit() {
        // async form submit
        if (this.options.async === true) {
            const target = `${GLOBALS.FORM_ACTION}?action=${this.action}`; // eslint-disable-line
            const that = this;
            /* eslint-disable */
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(GLOBALS.RECAPTCHA_SITE_KEY, { action: "submit" })
                    .then(function (token) {
                        that.data.fields.recaptcha_response = token;
                        httpA
                            .post("", target, qs.stringify(that.data))
                            .then(({ ...response }) => {
                                if (response.status === 200 && response.data.status) {
                                    if (that.events[Form.EVENT_SUBMIT_COMPLETED]) {
                                        that.events[Form.EVENT_SUBMIT_COMPLETED](response);
                                    }
                                } else if (that.events[Form.EVENT_SUBMIT_FAILED]) {
                                    that.events[Form.EVENT_SUBMIT_FAILED](response);
                                }
                            })
                            .catch((e) => {
                                console.error(e); // eslint-disable-line
                            });
                    })
                    .catch((e) => {
                        const $state = that.$form.querySelector(".form__state");
                        $state.classList.add("show");
                        $state.innerHTML = "";

                        const $message = document.createElement("div");
                        $message.classList.add("form__message", "failed");
                        $message.innerText =
                            "Une erreur est survenue, veuillez recharger la page et rééssayer.";
                        $state.appendChild($message);

                        console.error(e); // eslint-disable-line
                    });
            });
            /* eslint-enable */
        } else {
            // normal submit
            this.form.submit();
        }
    }

    static getSelectValues(select) {
        let result = '';
        const options = select && select.options;
        let opt = null;

        for (let i = 0; i < options.length; i += 1) {
            opt = options[i];
            if (opt.selected) result += `${opt.value}, `;
        }
        return result.substring(0, result.length - 2);
    }

    /**
     * Applies to all form fields a given key / value
     * @param {string} attribute - HTML attribute
     * @param {any} value
     */
    applyToAll(attribute, value, applyToSubmit = true) {
        if (applyToSubmit && this.submit) this.submit[attribute] = value;

        this.fields.forEach((field) => {
            if (field) field[attribute] = value; // eslint-disable-line
        });
    }

    /**
     * Disable form
     */
    disable() {
        this.form.classList.add('disabled');
        this.applyToAll('disabled', true, false);
    }

    /**
     * Enable form
     */
    enable() {
        this.form.classList.remove('disabled');
        this.applyToAll('disabled', false, false);
    }

    setSubmitLabel(value) {
        if (!this.submitLabel) {
            this.submitLabel = this.submit.querySelector('span')
                ? this.submit.querySelector('span').innerText
                : this.submit.innerText;
        }

        if (this.submit.querySelector('span')) {
            this.submit.querySelector('span').innerText = value || this.submitLabel;
        } else {
            this.submit.innerText = value || this.submitLabel;
        }
    }

    /**
     * Disable submit button
     */
    disableSubmit() {
        this.submit.classList.add('disabled');
        this.submit.setAttribute('disabled', 'true');

        this.setSubmitLabel("En cours d'envoi");
    }

    /**
     * Enable submit button
     */
    enableSubmit() {
        this.submit.classList.remove('disabled');
        this.submit.removeAttribute('disabled');

        this.setSubmitLabel();
    }

    /**
     * Get the message associated with a given code
     * @param {string} code
     * @param {string} name
     */
    getMessage(code, name = null) {
        const messages = this.MESSAGES;

        if (messages[code]) return messages[code];
        if (messages[name] && messages[name][code]) return messages[name][code];

        if (code === undefined && name === null) {
            console.warn("Google ReCaptcha fail"); // eslint-disable-line
        } else if (this.options.debug) {
            console.warn(`Tried to load message "${code}" but failed`); // eslint-disable-line
        }
        return null;
    }

    /**
     * Returns a feedback object
     * @param {string} Field identifier e.g TEX
     * @param {string} name - Name property
     * @param {any} value - Cleaned up value
     * @param {boolean} required - Required attribute value
     * @param {boolean} empty - Value is considered empty
     * @param {boolean} valid - Result of the validation test
     * @param {string|array} suffix - Code suffix e.g FOR or REQ
     * @param {string} customMess - Bypass validation message w/ a custom message
     * @return {Object}
     */
    feedback(
        field,
        name,
        value,
        required = false,
        empty = false,
        valid = true,
        suffix = '',
        customMess = null,
    ) {
        const codes = [];

        // generate error codes
        if (required && empty) codes.push(`F0${field}REQ`);

        if (!valid && !empty) {
            if (Array.isArray(suffix)) suffix.forEach((s) => codes.push(`F0${field}${s}`));
            else codes.push(`F0${field}${suffix}`);
        }

        // retrieve error code messages
        const messages = codes.map((c) => this.getMessage(c, name));

        if (customMess) messages.push(customMess);

        const success = codes.length === 0; // success if no error codes are generated
        const message = success ? 'Success' : messages.join(' | ');

        return {
            success,
            message,
            name,
            value,
        };
    }

    static validateFrenchPhone(number, onlyMobile = false) {
        const regex = new RegExp(
            onlyMobile ? /^(06|07)[0-9]{8}$/gi : /^(01|02|03|04|05|06|07|08)[0-9]{8}$/gi,
        );
        return regex.test(number);
    }

    static validateEmailNotOnlyNumber(email) {
        return email.split('@')[0].match(/[a-zA-Z]+/);
    }
}

Form.EVENT_SUBMIT = 'submit';
Form.EVENT_SUBMIT_FAILED = 'submit.failed';
Form.EVENT_SUBMIT_COMPLETED = 'submit.completed';
Form.DEFAULT_CONFIG = {
    async: true,
    strictMode: false,
    debug: false,
};

export { FormError };

export default Form;
